import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/RecentMemberOrders';

export const RECENT_MEMBER_ORDERS_GET_SUCCESS = `${rootActionPath}/GET_${SUCCESS_SUFFIX}`;
export const RECENT_MEMBER_ORDERS_GET_FAILURE = `${rootActionPath}/GET_${FAILURE_SUFFIX}`;

export const RECENT_MEMBER_ORDERS_PENDING_GET_SUCCESS = `${rootActionPath}/GET_/PENDING/${SUCCESS_SUFFIX}`;
export const RECENT_MEMBER_ORDERS_PENDING_GET_FAILURE = `${rootActionPath}/GET_/PENDING/${FAILURE_SUFFIX}`;
